<ng-form #documentForm="ngForm" novalidate class="form__cont" *ngIf="legalCounsel">
    <h2 class="form__title">Legal Counsel</h2>
  
    <div class="tabs__control">
      <ul class="inline-list">
        <li>
          <button matTooltip="Delete" *ngIf="!!legalCounsel?.id" color="primary" mat-raised-button
            (click)="delete(legalCounsel)">
            <!-- <mat-icon><img src="assets/images/icon-unsuccess.svg" /></mat-icon> -->
            Delete
          </button>
        </li>
        <li>
          <button matTooltip="Save" *ngIf="documentForm.valid" mat-icon-button (click)="save(legalCounsel)">
            <mat-icon><img src="assets/images/icon-save.svg" /></mat-icon>
          </button>
        </li>
        <li>
          <button matTooltip="Close" mat-icon-button [routerLink]="['..']">
            <mat-icon><img src="assets/images/icon-close.svg" /></mat-icon>
          </button>
        </li>
      </ul>
    </div>
  
    <h3 class="full__section">Legal Counsel Information</h3>
    <div class="alert alert-warning full__section" *ngIf="error$ | async as error">
      {{ error?.error?.error?.businessError ? error?.error?.error?.businessError : 'Unknown Server Error, Please contact support'}}
    </div>
  
    <div class="form-container">
      <mat-form-field appearance="outline">
        <mat-label>Legal Counsel Name</mat-label>
        <input matInput #fullname="ngModel" required name="fullname" [(ngModel)]="legalCounsel.fullname" />
        <mat-error *ngIf="fullname?.errors?.required">
          Field is required
        </mat-error>
      </mat-form-field>
    </div>
    
    <div class="form-container">
      <mat-form-field appearance="outline">
        <mat-label>Legal Counsel Email</mat-label>
        <input matInput #email="ngModel" required name="email" [(ngModel)]="legalCounsel.email"
          pattern="^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$" />
  
        <!-- [a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z0-9]{2,} -->
        <mat-error *ngIf="email?.errors?.required">
          Field is required
        </mat-error>
        <mat-error *ngIf="email?.errors?.pattern">
          Invalid Email Address
        </mat-error>
      </mat-form-field>
    </div>
    
  </ng-form>
  
  
  <!-- {{legalCounsel$ | async | json}} -->
  